import { CohortConfigApi } from '../api/CohortConfigApi'

export interface CreateCustomCohortHooks {
  start: () => void
  finish: () => void
}

export class CreateCustomCohortFlow {
  constructor(
    private readonly api = new CohortConfigApi(),
    private readonly hooks: CreateCustomCohortHooks = { start: () => {}, finish: () => {} },
  ) {}

  async execute(workspaceId: number, eventSlugNames: string[]): Promise<void> {
    this.hooks.start()
    try {
      await this.api.createCustomCohort(workspaceId, eventSlugNames)
    } finally {
      this.hooks.finish()
    }
  }
}
